var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoryCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2207_50087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16C9.44772 16 9 15.5523 9 15V9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44772 11 9V15C11 15.5523 10.5523 16 10 16Z",
    fill: "#009788"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12C14 12.5523 13.5523 13 13 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H13C13.5523 11 14 11.4477 14 12Z",
    fill: "#009788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.99515C10 3.44554 10.4469 2.99431 10.9931 3.05496C11.8341 3.14833 12.6594 3.36002 13.4442 3.68508C14.5361 4.13738 15.5282 4.80031 16.364 5.63604C17.1997 6.47177 17.8626 7.46392 18.3149 8.55585C18.7672 9.64778 19 10.8181 19 12C19 13.1819 18.7672 14.3522 18.3149 15.4442C17.8626 16.5361 17.1997 17.5282 16.364 18.364C15.5282 19.1997 14.5361 19.8626 13.4441 20.3149C12.6594 20.64 11.8341 20.8517 10.9931 20.945C10.4469 21.0057 10 20.5545 10 20.0048C10 19.4552 10.4477 19.0169 10.9918 18.9392C11.5712 18.8564 12.1393 18.7011 12.6825 18.4761C13.5329 18.1238 14.3057 17.6075 14.9566 16.9566C15.6075 16.3057 16.1238 15.533 16.4761 14.6825C16.8284 13.832 17.0097 12.9205 17.0097 12C17.0097 11.0795 16.8284 10.168 16.4761 9.31751C16.1238 8.46705 15.6075 7.69431 14.9566 7.0434C14.3057 6.39249 13.533 5.87616 12.6825 5.52389C12.1393 5.2989 11.5712 5.14364 10.9918 5.06083C10.4477 4.98306 10 4.54476 10 3.99515Z",
    fill: "#009788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8788 6.36171C20.3511 5.97459 21.0536 6.04079 21.3863 6.55291C22.4722 8.22476 23.0384 10.1912 22.998 12.2012C22.9575 14.2112 22.3127 16.1533 21.1603 17.7801C20.8073 18.2784 20.1027 18.3163 19.6464 17.9105C19.19 17.5047 19.1568 16.8093 19.4939 16.3001C20.3047 15.0757 20.7571 13.6399 20.787 12.1567C20.8168 10.6735 20.4225 9.22069 19.6617 7.96465C19.3453 7.44233 19.4065 6.74883 19.8788 6.36171Z",
    fill: "#009788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11094 13.3566C1.56928 13.4497 1.04885 13.0858 1.01604 12.5372C0.993168 12.1546 0.994757 11.7709 1.0208 11.3885C1.05814 10.8401 1.58157 10.4805 2.12244 10.5781C2.66331 10.6758 3.01511 11.1942 2.995 11.7435C2.98945 11.8951 2.98882 12.0469 2.99312 12.1985C3.00868 12.7479 2.6526 13.2634 2.11094 13.3566Z",
    fill: "#009788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9561 19.4035C6.7471 19.9118 6.1622 20.1593 5.68005 19.8954C4.93834 19.4896 4.25746 18.9813 3.6576 18.3855C3.26766 17.9981 3.33866 17.3671 3.76664 17.0222C4.19461 16.6774 4.81683 16.7511 5.21874 17.126C5.59258 17.4747 6.00346 17.7814 6.44401 18.0408C6.91764 18.3196 7.16509 18.8952 6.9561 19.4035Z",
    fill: "#009788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78959 6.94942C3.36318 6.60265 3.29506 5.97124 3.68677 5.58571C4.28394 4.99795 4.96031 4.49642 5.6962 4.09574C6.17889 3.83292 6.76329 4.08152 6.97124 4.59026C7.17919 5.09901 6.93057 5.67414 6.45637 5.95198C6.02037 6.20744 5.61325 6.50932 5.24215 6.85231C4.83854 7.22536 4.21599 7.29619 3.78959 6.94942Z",
    fill: "#009788"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2207_50087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryCarousel);
export default __webpack_public_path__ + "static/media/story-carousel.c057fefb99f4ea69ed97b6e2eb902e31.svg";
export { ForwardRef as ReactComponent };